<template>
  <div>
    <b-table
      ref="ref-table-areas-module"
      :per-page="paginate.perPage"
      :current-page="paginate.currentPage"
      sticky-header="50vh"
      small
      class="position-relative"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="showFields"
      primary-key="id"
    >
      <template #table-busy>
        <b-skeleton-table
          :headers="fields"
          :rows="paginate.perPage"
          :columns="fields.length"
          :table-props="{ bordered: true, striped: true }"
        />
      </template>
      <template #cell(module)="data">
        {{ $t(data.item.module_name) }}
      </template>
      <template #cell(areas)="data">
        <div
          v-for="(area, index) in JSON.parse(data.item.areas)"
          :key="index"
          class="d-inline"
        >
          <b-badge
            style="margin-bottom: 3px; margin-left: 3px"
            variant="light-success"
            >{{ area.area_name }}</b-badge
          >
        </div>
      </template>
      <template #cell(tracking)="data">
        <feather-icon
          icon="MenuIcon"
          size="16"
          class="text-info cursor-pointer"
          @click="trackingModal(data.item)"
        />
      </template>
      <template #cell(actions)="data">
        <feather-icon
          icon="EditIcon"
          size="16"
          class="text-warning cursor-pointer"
          @click="showModal(data.item)"
        />
      </template>
    </b-table>
    <areas-module-edit-modal
      v-if="showEditModal"
      :modalData="modalData"
      @refreshTable="refreshTable"
      @hideModal="showEditModal = false"
    />
    <areas-module-tracking
      v-if="showTrackingModal"
      :moduleId="moduleId"
      @hideModal="showTrackingModal = false"
    />
  </div>
</template>

<script>
import Fields from "@/views/settings/views/areas-module/data/areas-module.fields.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import AreasModuleService from "@/views/settings/views/areas-module/service/areas-module.service.js";
import AreasModuleEditModal from "@/views/settings/views/areas-module/components/modals/AreasModuleEdit.vue";
import AreasModuleTracking from "@/views/settings/views/areas-module/components/modals/AreasModuleTracking.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
    AreasModuleEditModal,
    AreasModuleTracking,
  },
  data() {
    return {
      params: 1,
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showEditModal: false,
      showTrackingModal: false,
      modalData: {},
      moduleId: null,
    };
  },
  computed: {
    showFields() {
      return Fields.map((item) => ({ ...item, label: this.$t(item.label) }));
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    fields() {
      return Fields.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
    },
  },
  created() {},
  methods: {
    async myProvider() {
      try {
        const { data } = await AreasModuleService.getAreasModule();
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    showModal(item) {
      this.modalData = item;
      this.showEditModal = true;
    },
    showTracking(item) {
      this.moduleId = item.module_id;
      this.showTrackingModal = true;
    },
    refreshTable() {
      this.$refs["ref-table-areas-module"].refresh();
    },
    async trackingModal(item) {
      this.moduleId = item.module_id;
      this.showTrackingModal = true;
    },
  },
};
</script>

<style>
</style>